import React from 'react'
import { Modal } from 'react-bootstrap'
import clsx from 'clsx'

/**
 * @param {{
 *    className?: string
 *    centered?: boolean
 *    show: boolean
 *    size?: 'sm' | 'lg' | 'xl'
 * }} props
 * @param {any} ref
 * @returns {React.Component}
 */
const ZariModal = ({ className, onHide, ...props }) => {
  return (
    <Modal
      {...props}
      centered={true}
      onHide={e => {}}
      className={clsx('zr-form__modal', className)}
    />
  )
}

ZariModal.Header = Modal.Header
ZariModal.Title = Modal.Title
ZariModal.Body = Modal.Body
ZariModal.Footer = Modal.Footer

export default ZariModal
